<template lang="html">
    <div class="row">
        <div class="col-12 grid-margin">
            <div class="card">
                <div class="card-body">
                    <h5 class="card-title mb-4">Edit Item</h5>
                    <form class="forms-sample">
                        <div class="row">
                            <div class="col-md-6">
                                <b-form-group label="Item Name">
                                    <b-form-input v-model="item.itemName" 
                                                    type="text" 
                                                    placeholder="Name">
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-6">
                                <b-form-group label="Category">
                                    <b-form-select class="mb-3"
                                                    text-field="name"
                                                    value-field="categoryId" 
                                                    :options="categories"
                                                    v-model="item.categoryId"/>
                                 </b-form-group>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <b-form-group label="Price">
                                    <b-form-input v-model="item.originalPrice" 
                                                    type="text" 
                                                    placeholder="Price Before Tax">
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-6">
                                <b-form-group label="Tax">
                                    <b-form-select class="mb-3"
                                                    text-field="value"
                                                    value-field="taxId" 
                                                    :options="taxes"
                                                    v-model="item.taxId"/>
                                 </b-form-group>
                            </div>
                        </div>
                        
                        <b-form-group label="Description">
                            <b-form-textarea v-model="item.description" 
                                             :rows="3"
                                             :max-rows="6"
                                             placeholder="Description">
                            </b-form-textarea>
                        </b-form-group>
                        <div class="row">
                            <div class="col-md-6">
                                <b-form-group label="Options">
                                    <b-form-textarea  
                                             :rows="3"
                                             :max-rows="6"
                                             placeholder="Here you define options to make item">
                                    </b-form-textarea>
                                </b-form-group>
                            </div>
                            <div class="col-md-6">
                                <b-form-group label="Images">
                                    <image-uploader 
                                        :imageUrl="item.imageUrl"
                                        @ready-upload="handleReadyUpload"
                                    />
                                </b-form-group>
                            </div>
                        </div>
                        <div class="container-fluid mt-5 w-100">
                            <hr>
                            <b-button variant="success" 
                                    class="mr-2"
                                    v-on:click="handleBtnSave">
                                    Save
                            </b-button>
                            <b-button variant="light" 
                                    v-on:click="handleBtnCancel">
                                    Cancel
                            </b-button>
                        </div>
                    </form> 
                </div>
            </div>
        </div>      
    </div>
</template>

<script lang="js">
import { mapState, mapGetters } from'vuex'
import ItemBaseForm from './ItemBaseForm'
import ImageUploader from '../Bases/ImageUploader'
export default{
    name: 'itemeditform',
    extends: ItemBaseForm,
    components: {
        ImageUploader
    },
    computed: {
        ...mapState({
            categories: state => state.categories.categories,
            taxes: state => state.taxes.taxes
        }),
        ...mapGetters([
            'items/getItemById'
        ])
    },
    methods: {
        handleReadyUpload(file) {
            this.imagesForUpload = file;
        }
    },
    async created() {
        this.$store.dispatch('categories/getCategoriesAction');
        this.$store.dispatch('taxes/getTaxesAction');
        this.setAction('items/updateItemAction');
        this.item = this.$store
                        .getters['items/getItemById'](this.$route.params.id);
        await this.$store.dispatch('items/getImageUriAction', this.item);
    }
}
</script>